import { atom } from 'jotai'
import { BoundingBox } from './math'

export type Coordinates = { x: number; y: number }
export type Size = { width: number; height: number }

export type TransformerState = {
	scale: number
	rotation: number
	offset: Coordinates
}

export type TransformerSubjectSize = Size

export const transformerStateAtom = atom<TransformerState>({
	scale: 1,
	rotation: 0,
	offset: { x: 0, y: 0 },
})
transformerStateAtom.debugLabel = 'transformerStateAtom'

// this is distinct from the main state so we can preview the changes without
// performing an update on the main state. This also means we can never accidentally
// save an interim action.

// should this be a getter that derives the new state from the current + action state using the reducer?
export const transformerPreviewStateAtom = atom<TransformerState | null>(null)
transformerPreviewStateAtom.debugLabel = 'transformerPreviewStateAtom'

export type TransformerAnchor = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'

export type TransformerActionState = null | {
	type: 'offset'
	start: Coordinates
} | {
	type: 'rotation'
	start: Coordinates
	center: Coordinates
	startRotation: number
} | {
	type: 'scale'
	start: Coordinates
	center: Coordinates
	startScale: number
	size: Size
	startBoundingBox: BoundingBox
	anchor: TransformerAnchor
}

export const transformerActionStateAtom = atom<TransformerActionState>(null)
transformerActionStateAtom.debugLabel = 'transformerActionStateAtom'
